import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Menu2Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M30.251 4.86914V6.65039C30.251 8.3693 28.8528 9.76758 27.1338 9.76758H25.3525C23.6336 9.76758 22.2354 8.3693 22.2354 6.65039V4.86914C22.2354 3.15024 23.6336 1.75195 25.3525 1.75195H27.1338C28.8528 1.75195 30.251 3.15024 30.251 4.86914Z"
        fill="currentColor"
      />
      <path
        d="M30.251 15.1084V16.8896C30.251 18.6085 28.8528 20.0069 27.1338 20.0069H25.3525C23.6336 20.0069 22.2354 18.6085 22.2354 16.8896V15.1084C22.2354 13.3895 23.6336 11.9912 25.3525 11.9912H27.1338C28.8528 11.9912 30.251 13.3895 30.251 15.1084Z"
        fill="currentColor"
      />
      <path
        d="M9.76758 15.1084V16.8896C9.76758 18.6085 8.3693 20.0069 6.65039 20.0069H4.86914C3.15024 20.0069 1.75195 18.6085 1.75195 16.8896V15.1084C1.75195 13.3895 3.15024 11.9912 4.86914 11.9912H6.65039C8.3693 11.9912 9.76758 13.3895 9.76758 15.1084Z"
        fill="currentColor"
      />
      <path
        d="M9.76758 25.3525V27.1338C9.76758 28.8528 8.3693 30.251 6.65039 30.251H4.86914C3.15024 30.251 1.75195 28.8528 1.75195 27.1338V25.3525C1.75195 23.6336 3.15024 22.2354 4.86914 22.2354H6.65039C8.3693 22.2354 9.76758 23.6336 9.76758 25.3525Z"
        fill="currentColor"
      />
      <path
        d="M9.76758 4.86914V6.65039C9.76758 8.3693 8.3693 9.76758 6.65039 9.76758H4.86914C3.15024 9.76758 1.75195 8.3693 1.75195 6.65039V4.86914C1.75195 3.15024 3.15024 1.75195 4.86914 1.75195H6.65039C8.3693 1.75195 9.76758 3.15024 9.76758 4.86914Z"
        fill="currentColor"
      />
      <path
        d="M20.0069 4.86914V6.65039C20.0069 8.3693 18.6085 9.76758 16.8896 9.76758H15.1084C13.3895 9.76758 11.9912 8.3693 11.9912 6.65039V4.86914C11.9912 3.15024 13.3895 1.75195 15.1084 1.75195H16.8896C18.6085 1.75195 20.0069 3.15024 20.0069 4.86914Z"
        fill="currentColor"
      />
      <path
        d="M20.0069 25.3525V27.1338C20.0069 28.8528 18.6085 30.251 16.8896 30.251H15.1084C13.3895 30.251 11.9912 28.8528 11.9912 27.1338V25.3525C11.9912 23.6336 13.3895 22.2354 15.1084 22.2354H16.8896C18.6085 22.2354 20.0069 23.6336 20.0069 25.3525Z"
        fill="currentColor"
      />
      <path
        d="M20.0069 15.1084V16.8896C20.0069 18.6085 18.6085 20.0069 16.8896 20.0069H15.1084C13.3895 20.0069 11.9912 18.6085 11.9912 16.8896V15.1084C11.9912 13.3895 13.3895 11.9912 15.1084 11.9912H16.8896C18.6085 11.9912 20.0069 13.3895 20.0069 15.1084Z"
        fill="currentColor"
      />
      <path
        d="M30.251 25.3525V27.1338C30.251 28.8528 28.8528 30.251 27.1338 30.251H25.3525C23.6336 30.251 22.2354 28.8528 22.2354 27.1338V25.3525C22.2354 23.6336 23.6336 22.2354 25.3525 22.2354H27.1338C28.8528 22.2354 30.251 23.6336 30.251 25.3525Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
